import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DocumentViewerActions = createActionGroup({
  source: 'Document Viewer',
  events: {
    'Open Document From Chat Message': props<{
      chatMessageId: number;
      documentUuid: string;
    }>(),
    'Open Document From Assistant Profile': props<{
      documentUuid: string;
      chatMessageId: number | null;
    }>(),
    'Toggle Assistant Profile And Conversation View Mode': emptyProps(),
    'Close Document Viewer': emptyProps(),
    'Close Document Viewer And Open Assistant Profile': emptyProps(),
  },
});
